export default __webpack_public_path__ + "static/media/img-09-mini.8e757592.png";